<template>
  <div class="card" v-loading="loading">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-5">
          <div>
            <p class="text-deepBlue font-semibold">Lead Status</p>
          </div>
          <hr class="mb-4 mt-2" />
          <div class="mb-24">
            <table class="w-full">
              <thead>
                <tr>
                  <td class="w-4/5">Status</td>
                  <td class="w-1/5">Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(status, index) in leadStatuses" :key="index">
                  <td class="font-semibold capitalize">{{ status }}</td>
                  <td class="flex cursor-pointer">
                    <span @click="editLeadStatus(index)">
                      <img
                        src="@/assets/images/icons/edit.svg"
                        alt="edit icon"
                      />
                    </span>
                    <span class="pl-2" @click="deleteLeadStatus(index)">
                      <img src="@/assets/images/icons/delete-icon.svg" />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="absolute bottom-0">
            <base-button
              text="Add"
              background="bg-darkBlue"
              p="px-8 py-2"
              color="text-white"
              @click="isLeadStatusModal = true"
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-7">
          <div>
            <p class="text-deepBlue font-semibold">Pipeline Movement</p>
          </div>
          <hr class="mb-4 mt-2" />
          <div>
            <div>
              <p class="text-sm font-semibold">
                Convert from Lead to Opportunity:
              </p>
              <div class="flex items-center conditions-wrapper">
                <div class="flex flex-wrap ">
                  <div
                    v-for="(condition, index) in pipelineSettings
                      .leadToOpportunity.conditions"
                    :key="index"
                    class="condition flex"
                  >
                    <p>{{ condition.description }}</p>
                  </div>
                </div>
                <div
                  class="w-8 h-8"
                  @click="editPipelineSetting('leadToOpportunity')"
                >
                  <img
                    src="@/assets/images/icons/edit.svg"
                    alt="edit icon"
                    class="cursor-pointer "
                  />
                </div>
              </div>
            </div>
            <div>
              <p class="text-sm font-semibold">Convert from Lead to Sales:</p>
              <div class="flex items-center conditions-wrapper">
                <div class="flex flex-wrap ">
                  <div
                    v-for="(condition, index) in pipelineSettings.leadToSale
                      .conditions"
                    :key="index"
                    class="condition flex"
                  >
                    <p>{{ condition.description }}</p>
                  </div>
                </div>
                <div class="w-8 h-8" @click="editPipelineSetting('leadToSale')">
                  <img
                    src="@/assets/images/icons/edit.svg"
                    alt="edit icon"
                    class="cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <div>
              <p class="text-sm font-semibold">
                Convert from Opportunity to Sales:
              </p>
              <div class="flex items-center conditions-wrapper">
                <div class="flex flex-wrap ">
                  <div
                    v-for="(condition, index) in pipelineSettings
                      .opportunityToSale.conditions"
                    :key="index"
                    class="condition flex"
                  >
                    <p>{{ condition.description }}</p>
                  </div>
                </div>
                <div
                  class="w-8 h-8"
                  @click="editPipelineSetting('opportunityToSale')"
                >
                  <img
                    src="@/assets/images/icons/edit.svg"
                    alt="edit icon"
                    class="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pipeline-movement-modal
      v-if="isEditPipelineModal"
      :show-modal="isEditPipelineModal"
      @close-modal="isEditPipelineModal = false"
      :settingType="settingType"
      :pipelineSettings="pipelineSettings"
      @updated="getPipelineSettings"
    />

    <lead-status-modal
      :show-modal="isLeadStatusModal"
      @close-modal="
        (selectedLeadStatusIndex = null), (isLeadStatusModal = false)
      "
      :leadStatuses="leadStatuses"
      :selectedLeadStatusIndex="selectedLeadStatusIndex"
      @updated="getLeadStatusSettings"
    />
    <delete-lead-status-modal
      :show-modal="isDeleteLeadStatusModal"
      @close-modal="
        (selectedLeadStatusIndex = null), (isDeleteLeadStatusModal = false)
      "
      :leadStatuses="leadStatuses"
      :selectedLeadStatusIndex="selectedLeadStatusIndex"
      @deleted="getLeadStatusSettings"
    />
  </div>
</template>

<script>
import PipelineMovementModal from "../Modals/PipelineMovementForm.vue";
import LeadStatusModal from "../Modals/LeadStatusForm.vue";
import DeleteLeadStatusModal from "../Modals/DeleteLeadStatus.vue";

export default {
  name: "pipeline-settings",
  components: {
    PipelineMovementModal,
    LeadStatusModal,
    DeleteLeadStatusModal,
  },
  data() {
    return {
      leadStatuses: ["omo"],
      leadStatusSettings: {},
      selectedLeadStatusIndex: null,
      pipelineSettings: {
        leadToOpportunity: {
          conditions: [],
          slug: "leadToOpportunity",
          title: "Move customer from lead to opportunity",
        },
        leadToSale: {
          conditions: [],
          slug: "leadToSale",
          title: "Move customer from lead to sale",
        },
        opportunityToSale: {
          conditions: [],
          slug: "opportunityToSale",
          title: "Move customer from opportunity to sale",
        },
      },
      isEditPipelineModal: false,
      settingType: "leadToOpportunity",
      isLeadStatusModal: false,
      isDeleteLeadStatusModal: false,
      loading: true,
    };
  },
  mounted() {
    this.getPipelineSettings();
    this.getLeadStatusSettings();
    this.getMovementOptions();
  },
  methods: {
    async getPipelineSettings() {
      this.loading = true;
      try {
        const response = await this.$_getPipelineSettings();
        this.logResponse(response);
        this.pipelineSettings = response.data.settings
          ? response.data.settings
          : response.data;
        this.logResponse(this.pipelineSettings);
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getLeadStatusSettings() {
      this.loading = true;
      try {
        const response = await this.$_getLeadStatusSettings();
        this.log(response);
        this.leadStatuses = response.data.setting.setting;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getMovementOptions() {
      this.loading = true;
      try {
        const response = await this.$_getMovementOptions();
        this.logResponse(response);
        this.movementOptions = response.data.options;
      } catch (error) {
        this.handleError(error);
      }
    },
    editPipelineSetting(type) {
      this.settingType = type;
      this.isEditPipelineModal = true;
    },
    editLeadStatus(index) {
      this.selectedLeadStatusIndex = index;
      this.isLeadStatusModal = true;
    },
    deleteLeadStatus(index) {
      this.selectedLeadStatusIndex = index;
      this.isDeleteLeadStatusModal = true;
    },
  },
};
</script>

<style scoped>
thead td {
  font-weight: 600;
}
tbody tr:nth-child(odd) {
  background-color: #f6f9fc;
}
td {
  padding: 1rem 0.5rem;
  font-size: 1rem;
}
.address-options {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #dae8f6;
  border-radius: 5px;
}
.label {
  font-weight: 600;
  font-size: 0.9rem;
  padding-left: 0.5rem;
}

.condition {
  background: #f2f7fc;
  border: 0.5px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.35rem 0.5rem;
  margin: 0.2rem 1rem 0.2rem 0;
  font-size: 0.8rem;
  font-weight: 600;
}

.conditions-wrapper {
  border: 0.5px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.5rem;
}
</style>
